import { render } from "./skyBrightness.vue?vue&type=template&id=d312b580&ts=true"
import script from "./skyBrightness.vue?vue&type=script&lang=ts"
export * from "./skyBrightness.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__